import { Stack, Typography } from "@mui/material";
import React from "react";
import { AgendaSvg } from "@onair/ui/svg/agenda";

interface Props {
	showIcon?: boolean;
}

const AgendaHeader = ({ showIcon = true }: Props) => {
	return (
		<Stack direction="row" spacing={2} alignItems="center">
			{showIcon && <AgendaSvg />}
			<Stack direction="row" spacing={1} alignItems="center">
				<Typography variant="subtitle1" flex={1}>
					Agenda{" "}
				</Typography>
				<Typography variant="caption" color="text.secondary">
					(Lịch trình sự kiện)
				</Typography>
			</Stack>
		</Stack>
	);
};

export default AgendaHeader;
